import { useMultiplePickerField } from './useMultiplePickerField';
import { useSinglePickerField } from './useSinglePickerField';
/** @deprecated Use useSinglePickerField or useMultiplePickerField instead.*/
export const usePickerField = ({ value, } = {}) => {
    const { onChange: onMultipleChange, value: multipleValue, } = useMultiplePickerField(Array.isArray(value) ? value : []);
    const { onChange: onSingleChange, value: singleValue, } = useSinglePickerField(Array.isArray(value) ? undefined : value);
    return Array.isArray(value)
        ? {
            onChange: onMultipleChange,
            value: multipleValue,
        }
        : {
            onChange: onSingleChange,
            value: singleValue,
        };
};
